// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { Provider } from 'react-redux'

// Components
import ProductSearch from '../components/product_search'
import SortingSelect from 'store/modules/product/components/SortingSelect'
import FilterSelect from 'store/modules/product/components/FilterSelect'
import Themed from 'store/v2/react/components/Themed'

// Shared

const store = window.booqableStore

export default class FilterBar extends Component {
  static displayName = 'FilterBar'

  static propTypes = {
    filterKey: PropTypes.string,
    searchKey: PropTypes.string
  }

  static defaultProps = {
    filterKey: 'global'
  }

  render () {
    const filterKey = this.props.searchKey || this.props.filterKey

    // TODO: Re-enable filterselect when availability filtering perfomance is improved
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <div className="booqable-filter-bar">
              <ProductSearch filterKey={filterKey} />
              <SortingSelect filterKey={filterKey} />
              {false && <FilterSelect filterKey={filterKey} />}
            </div>
          </div>
        </Themed>
      </Provider>
    )
  }
}
